import $ from 'jquery';
import Swiper, { Lazy, Pagination } from 'swiper';
import throttle from 'lodash/throttle';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

/**
 * @type {string}
 */
const swiperOuterEl = '.destinations__swiper';

/**
 * @type {string}
 */
const swiperEl = '.swiper';

/**
 * @type {string}
 */
const swiperPreloader = 'c-slide-preloader';

/**
 * @type {*[]}
 */
const swipers = [];

/**
 * @type {string}
 */
const placeWrapperEl = '.destinations__point-wrapper';

/**
 * @type {string}
 */
const sectionEl = '.destinations__section';

/**
 * @type {string}
 */
const cardsWithLink = '.card-has-link';
function init() {
  $(cardsWithLink).on('click', function () {
    const linkUrl = $(this).find('.card-destination__link').attr('href');
    window.location = linkUrl;
  });

  // eslint-disable-next-line no-undef
  if ($(window).width() > breakpoints.desktop) {
    return;
  }

  $(swiperOuterEl).each((i, item) => {
    // eslint-disable-next-line no-use-before-define
    initSwiper(item);
  });
}

/**
 * @param slider
 */
function initSwiper(slider) {
  const swiper = new Swiper($(slider).find($(swiperEl))[0], {
    loop: true,
    init: false,
    spaceBetween: 30,
    slidesPerView: 'auto',
    speed: 300,
    modules: [Lazy, Pagination, HideOffscreenSlides],
    lazy: {
      loadPrevNext: true,
      preloaderClass: swiperPreloader,
      preloadImages: false,
    },
    pagination: {
      el: '.destinations__pagination',
      type: 'progressbar',
    },
  });

  swiper.init();
  swipers.push(swiper);
}

function setBackgroundImage(image) {
  const body = document.querySelector('body');
  const classNames = ['body--bg-image-wave', 'body--bg-image-rhombus', 'body--bg-image-shingles'];

  if (!image) {
    body.classList.remove(...classNames);
  }

  if (body.classList.contains('body--bg-image-changing') || body.classList.contains(`body--bg-image-${image}`)) {
    return;
  }

  if (classNames.some((className) => body.classList.contains(className))) {
    body.classList.add('body--bg-image-changing');

    window.setTimeout(() => {
      body.classList.remove(...classNames, 'body--bg-image-changing');

      body.classList.add(`body--bg-image-${image}`, 'body--bg-image-bottom');
    }, 1000);
  } else {
    body.classList.add(`body--bg-image-${image}`, 'body--bg-image-bottom');
  }
}

function initDestinations() {
  // eslint-disable-next-line no-undef
  if ($(window).width() < breakpoints.desktop) {
    setBackgroundImage('');
    return;
  }

  let backgroundImage = '';

  $(sectionEl).each((i, index) => {
    const relatedBackgroundImage = index.dataset.backgroundImage;

    if (relatedBackgroundImage) {
      if (i === 0) {
        backgroundImage = relatedBackgroundImage;
      }

      if (i !== 0 && $(index).offset().top < $(window).scrollTop() + 300) {
        backgroundImage = relatedBackgroundImage;
      }
    }

    $(index).find(placeWrapperEl).each((j, place) => {
      if (j !== 0) return;

      const relatedCaptionId = $(place).data('place');

      $(`${sectionEl} #${relatedCaptionId}`).removeClass('visible');

      if ($(place).offset().top < $(window).scrollTop() + 300) {
        $(`${sectionEl} #${relatedCaptionId}`).addClass('visible');
      }
    });

    $(index).find(placeWrapperEl).each((j, place) => {
      const relatedCaptionId = $(place).data('place');

      if (j !== 0) {
        $(`${sectionEl} #${relatedCaptionId}`).removeClass('visible');
      }

      if ($(place).offset().top - 80 < $(window).scrollTop()) {
        $(`${sectionEl} #${relatedCaptionId}`).addClass('visible');
      }

      if ($(place).offset().top + $(place).outerHeight() < $(window).scrollTop()) {
        $(`${sectionEl} #${relatedCaptionId}`).removeClass('visible');
      }
    });
  });

  setBackgroundImage(backgroundImage);
}

$(window).on('load resize', () => {
  init();
  initDestinations();
});

$(window).on('scroll', throttle(initDestinations, 300));
